<template>
	<component class="banner-wrapper" @click="onBannerClick">
		<img :src="data.coverUrl" :alt="data.title" class="banner-img">
	</component>
</template>

<script>
	export default {
		// name: 'bbs-banner',
		props: {
			data: {
				type: Object,
				default: {}
			},
			width: {
				type: Number,
				default: 1920
			}
		},
		computed: {
			// props() {
				// if (data.type.value === 1) {
				// 	return {
				// 		is: 'a',
				// 		href: data.link,
				// 		target: '_blank'
				// 	}
				// } else if (data.type.value === 2) {
				// 	return {
				// 		to: data.link,
				// 		is: 'nuxt-link'
				// 	}
				// } else return {is: 'div'}
			// }
		},
		methods: {
			onBannerClick() {
				this.$pushStat('PC-首页', '点击', this.data.name)
			}
		}
	}
</script>

<style>
	.banner-wrapper {
		display: block !important;
	}
</style>